// extracted by mini-css-extract-plugin
export var graph = "_008-throttle-vs-debounce-on-real-examples-module--graph--1dset";